import 'selectize';

(function($) {
	const feather = require('feather-icons');

	AOS.init();

	feather.replace();

	$(document).ready(() => {
		feather.replace();

		$('.button-selectize').selectize(
//			{
//			onInitialize: function () {
//				this.$control_input.attr('readonly', true);
//			}
//			}
		);

		document.body.style.setProperty('--cp-header-height', document.getElementById('masthead').offsetHeight + 'px');

		// Dropdowns
		var $dropdowns = getAll('.dropdown:not(.is-hoverable)');

		if ($dropdowns.length > 0) {
			$dropdowns.forEach(function ($el) {
				$el = $($el);
				$el.on('click', '.dropdown-trigger', function (event) {
					event.preventDefault();
					event.stopPropagation();
					$el.toggleClass('is-active');
				});
			});

			document.addEventListener('click', function (event) {
				closeDropdowns();
			});
		}

		function closeDropdowns () {
			$dropdowns.forEach(function ($el) {
				$el.classList.remove('is-active');
			});
		}

	} );

	function getAll (selector) {
		var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;

		return Array.prototype.slice.call(parent.querySelectorAll(selector), 0);
	}

	$(document).ready(() => {
		$('.cp-download--faq--item').on('click', function() {
			$(this).toggleClass('is-open');
		});
	});

	$(document).ready(function () {
		function updatePricingTable(productId, licenseLimit) {;
			const pricingPeriods = $('.cp-download-actions--pricing-period[data-product-id="' + productId + '"]');
				
			pricingPeriods.each(function () {
				const priceData = $(this).data('price-data');

				if(priceData[licenseLimit] === undefined) {
					$(this).hide();
					return;
				} else {
					$(this).show();
				}

				const price = priceData[licenseLimit];

				$(this).find('[name="edd_options[price_id]"]').val(price.id);

				const savingsEl = $(this).find('.cp-download-actions--pricing-period--savings');
				if ( price.savings ) {
					savingsEl.show();
					savingsEl.text('Save $' + Number(price.savings).toFixed(0));
				} else {
					savingsEl.hide();
				}


				$(this).find('.cp-download-actions--pricing-period--preview .regular-price').text( '' );
				if ( price.regular_amount != price.amount ) {
					$(this).find('.cp-download-actions--pricing-period--preview .regular-price').text( '$' + price.regular_amount );
				}

				$(this).find('.cp-download-actions--pricing-period--preview .amount').text('$' + price.amount);
			})

			$(document).ready(function () {
				// Hide cards from 7 and up initially
				$('.cp-download--cards--feature').slice(6).hide();

				// Show hidden cards when the button is clicked
				$('#show-more-features').click(function (e) {
					e.preventDefault();
					$('.cp-download--cards--feature:hidden').slideDown(); // Slide down hidden cards
					$(this).hide(); // Optionally hide the button after showing all cards
					AOS.refresh();
				});
			});
		}

		$('.edd-item-quantity').each(function() {
			const productId = $(this).data('product-id');
			const licenseLimit = $(this).val()

			$(this).on('change', (e) => {
				updatePricingTable(productId, e.target.value);
			})

			updatePricingTable(productId, licenseLimit);
		})
	});
})(jQuery);